/* ============================================================
   VEXA LUMEN — Interacciones (vanilla JS, sin dependencias)
   ============================================================ */
(function () {
  'use strict';

  var V = window.VEXA || { routes: {}, strings: {}, moneyFormat: '€{{amount_with_comma_separator}}' };

  /* ---------- Utilidades ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(root, evt, sel, fn) {
    root.addEventListener(evt, function (e) {
      var el = e.target.closest(sel);
      if (el && root.contains(el)) fn(e, el);
    });
  }
  function debounce(fn, ms) {
    var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); };
  }
  function formatMoney(cents, format) {
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var f = format || V.moneyFormat;
    function fixed(c, p, t, d) {
      p = typeof p === 'undefined' ? 2 : p;
      t = typeof t === 'undefined' ? '.' : t;
      d = typeof d === 'undefined' ? ',' : d;
      if (isNaN(c) || c == null) c = 0;
      c = (c / 100).toFixed(p);
      var parts = c.split('.');
      var euros = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + t);
      var dec = parts[1] ? d + parts[1] : '';
      return euros + dec;
    }
    switch ((f.match(placeholderRegex) || [])[1]) {
      case 'amount': value = fixed(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = fixed(cents, 0); break;
      case 'amount_with_comma_separator': value = fixed(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fixed(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fixed(cents, 2, "'", '.'); break;
      default: value = fixed(cents, 2, '.', ',');
    }
    return f.replace(placeholderRegex, value);
  }
  function toast(msg, isError) {
    var t = $('#vx-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'vx-toast';
      t.setAttribute('role', 'status');
      t.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);z-index:300;padding:14px 22px;border-radius:999px;font-size:14px;font-weight:600;backdrop-filter:blur(16px);transition:opacity .3s;max-width:90vw;text-align:center;';
      document.body.appendChild(t);
    }
    t.style.background = isError ? 'rgba(120,30,26,.92)' : 'rgba(18,16,26,.92)';
    t.style.border = '1px solid rgba(244,239,230,.25)';
    t.style.color = '#F4EFE6';
    t.textContent = msg;
    t.style.opacity = '1';
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.style.opacity = '0'; }, 3200);
  }
  function lockScroll(lock) { document.documentElement.style.overflow = lock ? 'hidden' : ''; }

  /* ---------- Header: ocultar al hacer scroll ---------- */
  (function () {
    var header = $('.site-header');
    if (!header) return;
    var lastY = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y > 160 && y > lastY + 6) header.classList.add('is-hidden');
      else if (y < lastY - 6 || y < 80) header.classList.remove('is-hidden');
      lastY = y;
    }, { passive: true });
  })();

  /* ---------- Apertura/cierre de overlays ---------- */
  function bindOverlay(rootSel, openBtnSel) {
    var root = $(rootSel);
    if (!root) return null;
    function open() {
      root.classList.add('is-open');
      root.removeAttribute('inert');
      lockScroll(true);
      var f = root.querySelector('input, a, button:not([data-overlay-close])');
      if (f) setTimeout(function () { f.focus(); }, 80);
    }
    function close() {
      root.classList.remove('is-open');
      lockScroll(false);
    }
    on(document, 'click', openBtnSel, function (e) { e.preventDefault(); open(); });
    on(root, 'click', '[data-overlay-close]', function (e) { e.preventDefault(); close(); });
    root.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    return { open: open, close: close, root: root };
  }

  var mobileMenu = bindOverlay('#MobileMenu', '[data-open-menu]');
  var searchModal = bindOverlay('#SearchModal', '[data-open-search]');
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { lockScroll(false); } });

  /* ---------- Carrito: drawer + AJAX ---------- */
  var Cart = {
    drawer: function () { return $('#CartDrawer'); },
    open: function () {
      var d = this.drawer();
      if (!d) { window.location.href = V.routes.cart || '/cart'; return; }
      d.classList.add('is-open');
      lockScroll(true);
    },
    close: function () {
      var d = this.drawer();
      if (d) d.classList.remove('is-open');
      lockScroll(false);
    },
    busy: function (b) {
      var d = this.drawer();
      if (d) d.classList.toggle('is-busy', b);
    },
    sectionsToRender: function () {
      var ids = ['cart-drawer'];
      var pageSection = $('[data-cart-section-id]');
      if (pageSection) ids.push(pageSection.getAttribute('data-cart-section-id'));
      return ids;
    },
    renderSections: function (sections) {
      if (!sections) return;
      Object.keys(sections).forEach(function (id) {
        var html = sections[id];
        if (!html) return;
        var wrapper = document.getElementById('shopify-section-' + id);
        if (!wrapper) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.firstElementChild;
        if (fresh) wrapper.innerHTML = fresh.innerHTML;
      });
      this.afterRender();
    },
    afterRender: function () {
      var root = $('#CartDrawerRoot');
      var count = root ? parseInt(root.getAttribute('data-count') || '0', 10) : null;
      if (count !== null) this.setCount(count);
    },
    setCount: function (n) {
      $$('.cart-count').forEach(function (el) {
        el.textContent = n;
        el.classList.toggle('is-empty', n === 0);
        el.classList.remove('bump');
        void el.offsetWidth;
        el.classList.add('bump');
      });
    },
    add: function (items, btn) {
      var self = this;
      if (btn) { btn.classList.add('is-loading'); btn.setAttribute('disabled', ''); }
      self.busy(true);
      return fetch(V.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items, sections: this.sectionsToRender().join(',') })
      }).then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || V.strings.cartError);
          self.renderSections(data.sections);
          self.open();
        });
      }).catch(function (err) {
        toast(err.message || V.strings.cartError, true);
      }).finally(function () {
        self.busy(false);
        if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('disabled'); }
      });
    },
    change: function (line, quantity) {
      var self = this;
      self.busy(true);
      return fetch(V.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: this.sectionsToRender().join(',') })
      }).then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || V.strings.cartError);
          self.renderSections(data.sections);
        });
      }).catch(function (err) {
        toast(err.message || V.strings.cartError, true);
      }).finally(function () { self.busy(false); });
    }
  };
  window.VexaCart = Cart;

  on(document, 'click', '[data-open-cart]', function (e) { e.preventDefault(); Cart.open(); });
  on(document, 'click', '[data-cart-close]', function (e) { e.preventDefault(); Cart.close(); });
  on(document, 'click', '#CartDrawer .cart-drawer__scrim', function (e) { e.preventDefault(); Cart.close(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && Cart.drawer() && Cart.drawer().classList.contains('is-open')) Cart.close();
  });

  /* Añadir al carrito: formularios de producto */
  on(document, 'submit', 'form[data-ajax-cart]', function (e, form) {
    e.preventDefault();
    var id = form.querySelector('[name="id"]');
    var qty = form.querySelector('[name="quantity"]');
    var btn = form.querySelector('[type="submit"]');
    if (!id || !id.value) return;
    Cart.add([{ id: parseInt(id.value, 10), quantity: qty ? Math.max(1, parseInt(qty.value, 10) || 1) : 1 }], btn);
  });

  /* Añadido rápido (tarjetas, upsells) */
  on(document, 'click', '[data-quick-add]', function (e, btn) {
    e.preventDefault();
    var vid = parseInt(btn.getAttribute('data-quick-add'), 10);
    if (vid) Cart.add([{ id: vid, quantity: 1 }], btn);
  });

  /* Steppers de cantidad */
  on(document, 'click', '[data-qty-plus], [data-qty-minus]', function (e, btn) {
    e.preventDefault();
    var qty = btn.closest('.qty');
    var input = qty && qty.querySelector('input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    var min = parseInt(input.min, 10);
    if (isNaN(min)) min = 1;
    val = btn.hasAttribute('data-qty-plus') ? val + 1 : val - 1;
    if (val < min) val = min;
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Cambios de cantidad en líneas del carrito */
  var lineChange = debounce(function (line, q) { Cart.change(line, q); }, 350);
  on(document, 'change', '[data-line-qty]', function (e, input) {
    var line = parseInt(input.getAttribute('data-line-qty'), 10);
    var q = Math.max(0, parseInt(input.value, 10) || 0);
    if (line) lineChange(line, q);
  });
  on(document, 'click', '[data-line-remove]', function (e, btn) {
    e.preventDefault();
    var line = parseInt(btn.getAttribute('data-line-remove'), 10);
    if (line) Cart.change(line, 0);
  });

  /* Nota del pedido (página carrito) */
  on(document, 'change', '[data-cart-note]', function (e, el) {
    fetch(V.routes.cartUpdate + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: el.value })
    });
  });

  /* ---------- Búsqueda predictiva ---------- */
  (function () {
    var input = $('#SearchModal input[type="search"]');
    var results = $('#SearchResults');
    if (!input || !results) return;
    var doSearch = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { results.classList.remove('has-results'); results.innerHTML = ''; return; }
      fetch(V.routes.predictiveSearch + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=7&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) {
            results.innerHTML = '<p style="padding:16px;color:rgba(244,239,230,.5);font-size:14px;">Sin resultados para «' + q.replace(/[<>&"]/g, '') + '»</p>';
            results.classList.add('has-results');
            return;
          }
          var html = products.map(function (p) {
            var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '&width=120" alt="" width="56" height="56" loading="lazy">' : '<span style="width:56px;height:56px;border-radius:10px;background:rgba(255,255,255,.06);display:block;"></span>';
            return '<a class="search-result" href="' + p.url + '">' + img + '<span><span class="t">' + p.title + '</span><br><span class="p">' + (p.price ? formatMoney(parseFloat(p.price) * 100) : '') + '</span></span></a>';
          }).join('');
          html += '<a class="search-results__all" href="' + (V.routes.search || '/search') + '?q=' + encodeURIComponent(q) + '">Ver todos los resultados →</a>';
          results.innerHTML = html;
          results.classList.add('has-results');
        })
        .catch(function () {});
    }, 240);
    input.addEventListener('input', doSearch);
  })();

  /* ---------- Página de producto ---------- */
  (function () {
    var root = $('[data-product-root]');
    if (!root) return;
    var dataEl = $('#ProductData', root);
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var form = $('form[data-ajax-cart]', root);
    var idInput = form && form.querySelector('[name="id"]');
    var priceBox = $('[data-price-box]', root);
    var atcBtn = $('[data-atc]', root);
    var stickyBar = $('#StickyATC');
    var stickyPrice = stickyBar && $('[data-sticky-price]', stickyBar);
    var stickyBtn = stickyBar && $('[data-sticky-atc]', stickyBar);

    function selectedOptions() {
      var opts = [];
      $$('[data-option-index]', root).forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        var checked = group.querySelector('input:checked');
        var select = group.tagName === 'SELECT' ? group : group.querySelector('select');
        opts[idx] = checked ? checked.value : (select ? select.value : null);
      });
      return opts;
    }
    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (val, i) { return val === opts[i]; });
      });
    }
    function renderPrice(v) {
      if (!priceBox || !v) return;
      var html = '';
      if (v.compare_at_price && v.compare_at_price > v.price) {
        html += '<s class="price__compare">' + formatMoney(v.compare_at_price) + '</s>';
      }
      html = '<span class="price__current">' + formatMoney(v.price) + '</span>' + html;
      priceBox.innerHTML = html;
      priceBox.classList.toggle('price--sale', !!(v.compare_at_price && v.compare_at_price > v.price));
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
    }
    function setButtons(v) {
      var label, disabled;
      if (!v) { label = V.strings.unavailable; disabled = true; }
      else if (!v.available) { label = V.strings.soldOut; disabled = true; }
      else { label = V.strings.addToCart; disabled = false; }
      [atcBtn, stickyBtn].forEach(function (b) {
        if (!b) return;
        var span = b.querySelector('.btn-label') || b;
        span.textContent = label;
        b.toggleAttribute('disabled', disabled);
        b.classList.toggle('is-disabled', disabled);
      });
    }
    function goToMedia(v) {
      if (!v || !v.featured_media) return;
      var slide = $('[data-media-id="' + v.featured_media.id + '"]', root);
      var track = $('.product-gallery__track', root);
      if (slide && track) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }
    function updateVariant() {
      var v = findVariant(selectedOptions());
      if (v && idInput) idInput.value = v.id;
      if (stickyBtn && v) stickyBtn.setAttribute('data-quick-add', v.id);
      renderPrice(v || null);
      setButtons(v);
      goToMedia(v);
      if (v) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      $$('[data-option-label]', root).forEach(function (lbl) {
        var idx = parseInt(lbl.getAttribute('data-option-label'), 10);
        var strong = lbl.querySelector('strong');
        var opts = selectedOptions();
        if (strong && opts[idx]) strong.textContent = opts[idx];
      });
    }
    on(root, 'change', '[data-option-index] input, [data-option-index] select, select[data-option-index]', updateVariant);

    /* Galería: thumbs + estado activo */
    var track = $('.product-gallery__track', root);
    if (track) {
      on(root, 'click', '[data-thumb-target]', function (e, th) {
        var slide = $('[data-media-id="' + th.getAttribute('data-thumb-target') + '"]', root);
        if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      });
      var slides = $$('.product-gallery__slide', root);
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            var id = en.target.getAttribute('data-media-id');
            $$('.product-gallery__thumb', root).forEach(function (t) {
              t.classList.toggle('is-active', t.getAttribute('data-thumb-target') === id);
            });
          }
        });
      }, { root: track, threshold: 0.6 });
      slides.forEach(function (s) { obs.observe(s); });
    }

    /* Barra sticky de compra */
    if (stickyBar && form) {
      var anchor = $('.buybox__actions', root) || form;
      var io = new IntersectionObserver(function (entries) {
        var en = entries[0];
        var pastIt = !en.isIntersecting && en.boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-visible', pastIt);
      }, { threshold: 0 });
      io.observe(anchor);
    }
  })();

  /* ---------- Carruseles ---------- */
  $$('.carousel').forEach(function (c) {
    var track = $('.carousel__track', c);
    var prev = $('[data-carousel-prev]', c.parentElement) || $('[data-carousel-prev]', c);
    var next = $('[data-carousel-next]', c.parentElement) || $('[data-carousel-next]', c);
    if (!track) return;
    function step() {
      var item = track.firstElementChild;
      if (!item) return 300;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return item.getBoundingClientRect().width + gap;
    }
    function update() {
      if (prev) prev.toggleAttribute('disabled', track.scrollLeft <= 4);
      if (next) next.toggleAttribute('disabled', track.scrollLeft >= track.scrollWidth - track.clientWidth - 4);
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', debounce(update, 80), { passive: true });
    update();
  });

  /* ---------- Animaciones de entrada ---------- */
  (function () {
    var els = $$('.reveal, .reveal-stagger');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-inview'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-inview'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  })();

  /* ---------- Marquee: duplicar contenido para bucle continuo ---------- */
  $$('.marquee').forEach(function (m) {
    var trackEl = $('.marquee__track', m);
    if (trackEl && !m.dataset.cloned) {
      var clone = trackEl.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      m.appendChild(clone);
      m.dataset.cloned = '1';
    }
  });
})();
